// OurValues.js
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Heart, Award, Handshake } from 'lucide-react';

const OurValues = () => {
  const values = [
    {
      icon: Shield,
      title: 'Integrity',
      description: 'We provide honest guidance, even when it means advising candidates not to proceed.',
      color: 'blue'
    },
    {
      icon: Heart,
      title: 'Responsibility',
      description: 'We understand that studying or working abroad is a major life decision and treat it with care and professionalism.',
      color: 'red'
    },
    {
      icon: Award,
      title: 'Professionalism',
      description: 'Our processes are structured, documented, and designed to support clarity and consistency.',
      color: 'green'
    },
    {
      icon: Handshake,
      title: 'Respect',
      description: 'We treat candidates, institutions, and employer partners with respect at all times.',
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      red: 'border-t-red-500',
      green: 'border-t-green-500',
      purple: 'border-t-purple-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            Our Values
          </h2>
        </motion.div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`bg-white p-6 border-t-2 ${getColorClasses(value.color)} hover:shadow-lg transition-shadow`}
              >
                <Icon size={32} className="text-gray-700 mb-4" />
                
                <h3 className="text-lg font-semibold text-[#202356] mb-3 leading-tight">
                  {value.title}
                </h3>
                
                <p className="text-gray-600 text-sm font-light leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurValues;
